import { SignUp } from '@clerk/react'
import { Zap } from 'lucide-react'

const clerkAppearance = {
  variables: {
    colorPrimary: '#6366f1',
    colorBackground: '#111827',
    colorInputBackground: '#0d0f1c',
    colorText: '#f1f5f9',
    colorTextSecondary: '#94a3b8',
    colorInputText: '#f1f5f9',
    colorTextOnPrimaryBackground: '#ffffff',
    borderRadius: '0.75rem',
    fontFamily: 'Inter, system-ui, sans-serif',
  },
  elements: {
    card: {
      background: '#111827',
      border: '1px solid rgba(99,102,241,0.25)',
      boxShadow: '0 0 60px rgba(99,102,241,0.12), 0 25px 50px rgba(0,0,0,0.6)',
    },
    headerTitle: { color: '#f1f5f9', fontWeight: '700' },
    headerSubtitle: { color: '#94a3b8' },
    socialButtonsBlockButton: {
      background: '#1e2130',
      border: '1px solid rgba(255,255,255,0.1)',
      color: '#f1f5f9',
    },
    socialButtonsBlockButtonText: { color: '#f1f5f9', fontWeight: '500' },
    providerIcon__apple: { filter: 'invert(1)' },
    dividerLine: { background: 'rgba(255,255,255,0.08)' },
    dividerText: { color: '#64748b' },
    formFieldLabel: { color: '#94a3b8' },
    formFieldInput: {
      background: '#0d0f1c',
      border: '1px solid rgba(255,255,255,0.1)',
      color: '#f1f5f9',
    },
    formFieldInputShowPasswordButton: { color: '#94a3b8' },
    formButtonPrimary: {
      background: 'linear-gradient(135deg,#6366f1,#4f46e5)',
      color: '#ffffff',
      fontWeight: '600',
    },
    footerActionText: { color: '#64748b' },
    footerActionLink: { color: '#818cf8', fontWeight: '600' },
    identityPreviewText: { color: '#f1f5f9' },
    identityPreviewEditButton: { color: '#818cf8' },
    alertText: { color: '#f87171' },
    formResendCodeLink: { color: '#818cf8' },
  },
}

export default function Register() {
  return (
    <div
      className="min-h-screen flex items-center justify-center p-4"
      style={{ background: 'radial-gradient(ellipse 80% 60% at 50% 0%,rgba(99,102,241,0.18) 0%,#050510 70%)' }}
    >
      <div className="w-full max-w-md">
        {/* Logo */}
        <div className="text-center mb-8">
          <div className="inline-flex items-center justify-center w-14 h-14 bg-brand-500 rounded-2xl mb-4 shadow-lg shadow-brand-500/30">
            <Zap size={28} className="text-white" />
          </div>
          <h1 className="text-2xl font-bold text-white">TradeBotHub Pro</h1>
          <p className="text-gray-400 mt-1 text-sm">Professional Algorithmic Trading</p>
        </div>

        <SignUp
          afterSignUpUrl="/dashboard"
          signInUrl="/login"
          appearance={clerkAppearance}
        />

        <p className="text-center text-xs text-gray-500 mt-6">
          ⚠️ Trading involves substantial risk of loss. Paper trade first.
        </p>
      </div>
    </div>
  )
}
